import ECOMemberProfile from '@/views/integrations/ECOMember/Profile.vue'

export const ecoMemberProfileRoutes = {
  path: '/integrations/eco-member-profile/:partyId',
  name: 'integrationEcoMemberProfile',
  meta: { requiresAuth: false },
  component: ECOMemberProfile,
  props: true,
}
